import { validateRegisteringEmailAddress } from 'ReduxLoop/registerAndConfirmInvitation/register/registerActions';

export class MyRegisterConfirmEmail {
  constructor($ngRedux) {
    'ngInject';

    this.editIcon = require('Img/edit.svg');
    this.arrowRight = require('Img/arrow-right.svg');
    this.$ngRedux = $ngRedux;

    this.unsubscribe = this.$ngRedux.connect((state) => ({
      duplicateEmails: state.register.duplicateEmails,
      emailWarnings:
        state.register.duplicateEmails.length > 0
          ? [
              {
                code: 'duplicate.email',
                message: `Dit e-mailadres staat al genoteerd bij ${
                  state.register.duplicateEmails.length
                } andere gebruiker${state.register.duplicateEmails.length > 1 ? 's.' : '.'}`,
              },
            ]
          : [],
    }))(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  $onInit() {
    this.emailAddress = this.resolve.emailAddress;
  }

  emailAddressChanged(e, emailAddress) {
    this.emailAddress = emailAddress;
    if (this.eForm.formGroups.email.valid) {
      this.$ngRedux.dispatch(validateRegisteringEmailAddress(this.emailAddress, this.resolve.dateOfBirth));
    }
  }

  onContinue() {
    this.submitAttempted = true;
    if (!this.eForm.valid || this.emailWarnings.length > 0) {
      return;
    }
    this.close({ $value: { newEmail: this.emailAddress } });
  }

  onIsMine() {
    console.log('duplicate email candidates', this.duplicateEmails);
    const duplicateEmail = this.duplicateEmails.reduce((duplicateEmail, current) => {
      if (duplicateEmail.hasDifferentRegistrationNumber && !current.hasDifferentRegistrationNumber) {
        return current;
      } else if (!duplicateEmail.hasSameDateOfBirth && current.hasSameDateOfBirth) {
        return current;
      } else if (duplicateEmail.type !== 'EMAILADDRESS_PRIMARY' && current.type === 'EMAILADDRESS_PRIMARY') {
        return current;
      }

      return duplicateEmail;
    });
    console.log('most important duplicate email', duplicateEmail);
    /* console.warn(
      `DUPLICATE_EMAIL: registering user, ${this.resolve.name}, claims ${this.emailAddress} is only his.`
    ); */
    this.close({ $value: { newEmail: this.emailAddress, duplicate: duplicateEmail } });
  }

  acceptRisks() {
    console.warn(
      `DUPLICATE_EMAIL: registering user, ${this.resolve.name}, indicates he shares ${this.emailAddress} with a colleague!!!!!.`
    );
    this.close({ $value: null });
  }

  cancel() {
    this.dismiss({ $value: 'cancel' });
  }
}
